import { inputAdornmentClasses, selectClasses } from '@mui/material';
import { inputClasses } from '@mui/material/Input';
import { inputBaseClasses } from '@mui/material/InputBase';
import { Theme } from '@mui/material/styles';

import { FONT_FAMILY } from '../consts';
import { ComponentsMuiInputBase } from '../types';

export function getMuiInputBase(theme: Theme): ComponentsMuiInputBase {
  return {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.paper,
        height: 48,
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.3s',

        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(4),

        [`&&& .${selectClasses.select}`]: {
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(10),
        },

        '&:after, &:before': {
          display: 'none',
        },

        '&:hover': {
          backgroundColor: theme.palette.grey[100],
          boxShadow: `0 0 0 2px ${theme.palette.grey[100]}`,
        },

        [`&&.${inputBaseClasses.focused}`]: {
          boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
          backgroundColor: theme.palette.background.paper,
        },

        [`&&.${inputBaseClasses.error}`]: {
          boxShadow: `0 0 0 2px ${theme.palette.error.main}`,
          color: theme.palette.error.main,

          '& input': {
            color: theme.palette.text.primary,
          },

          [`&:not(.${inputBaseClasses.multiline})`]: {
            '& svg': {
              color: theme.palette.error.main,
            },
          },

          [`& > .${selectClasses.select}, && > .${selectClasses.icon}`]: {
            color: theme.palette.error.main,
          },
        },

        [`&&.${inputBaseClasses.disabled}`]: {
          backgroundColor: theme.palette.grey[100],
        },

        'label + &&&': {
          marginTop: theme.spacing(2),
        },

        '& fieldset': {
          display: 'none',
        },

        [`&.${inputBaseClasses.multiline}`]: {
          alignItems: 'flex-start',

          height: 'unset',
          minHeight: 110,
          padding: theme.spacing(3, 4),

          caretColor: theme.palette.primary.main,

          '&.Mui-disabled': {
            [`.${inputAdornmentClasses.root}`]: {
              color: theme.palette.grey[400],
            },
          },

          [`.${inputAdornmentClasses.positionEnd}`]: {
            alignSelf: 'flex-end',

            height: 'unset',

            color: theme.palette.text.secondary,
            letterSpacing: 'unset',

            fontSize: 12,
            fontWeight: 500,
            lineHeight: 1.35,
          },

          [`.${inputBaseClasses.input}`]: {
            margin: 0,

            letterSpacing: '-0.01em',
            lineHeight: 1.4,
          },
        },
      },
      input: {
        height: 24,
        marginLeft: theme.spacing(2),
        color: theme.palette.grey[900],
        padding: 0,

        '&:first-of-type': {
          marginLeft: theme.spacing(1),
        },

        '&, &::placeholder': {
          fontFamily: FONT_FAMILY,
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '150%',
          fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
        },

        '&::placeholder': {
          color: theme.palette.grey[600],
          WebkitTextFillColor: theme.palette.grey[600],
          opacity: 1,
        },

        [`&.${inputClasses.disabled}`]: {
          '&, &::placeholder': {
            color: theme.palette.grey[400],
            WebkitTextFillColor: theme.palette.grey[400],
          },
        },
      },

      sizeSmall: {
        height: 40,
        borderRadius:  theme.shape.borderRadiusMd, // ex  14

        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(3),

        [`&&& .${selectClasses.select}`]: {
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(9),
        },
      },

      sizeExtraSmall: {
        height: 32,
        borderRadius: theme.shape.borderRadiusMd,

        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(3),

        [`&&& .${selectClasses.select}`]: {
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(9),
        },
      },

      colorSecondary: {
        backgroundColor: theme.palette.background.paper,
      },
      multiline: {
        height: 'unset',
      },
    },
  };
}
